import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useSearchParams } from "react-router-dom";
import "./App.css";
import { LangProvider, useLang } from "./lib/LangContext";
import LandingPage from "./pages/LandingPage";
import WizardPage from "./pages/WizardPage";
import ResultsPage from "./pages/ResultsPage";
import { Toaster } from "sonner";

/**
 * Reads `?lang=fr|en` from the URL once at mount, allowing hreflang and emails
 * to force the language on landing. Falls back to stored/browser lang otherwise.
 */
function LangURLSync() {
  const { setLang } = useLang();
  const [sp] = useSearchParams();
  useEffect(() => {
    const l = (sp.get("lang") || "").toLowerCase();
    if (l === "fr" || l === "en") setLang(l);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return null;
}

function AppShell() {
  return (
    <div className="App min-h-screen bg-slate-50 text-slate-900">
      <LangURLSync />
      <Toaster richColors position="top-center" />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/diagnostic" element={<WizardPage />} />
        <Route path="/resultats" element={<ResultsPage />} />
        <Route path="/results" element={<ResultsPage />} />
        <Route path="*" element={<LandingPage />} />
      </Routes>
    </div>
  );
}

// Use PUBLIC_URL as router basename ONLY when the current URL actually starts
// with it (production behind /produits/roadmap-generator). In the Emergent
// preview (served at root '/'), fall back to an empty basename so React Router
// can match the '/' route.
const PUBLIC_URL = process.env.PUBLIC_URL || "";
const ROUTER_BASENAME =
  PUBLIC_URL && typeof window !== "undefined" && window.location.pathname.startsWith(PUBLIC_URL)
    ? PUBLIC_URL
    : "";

export default function App() {
  return (
    <LangProvider>
      <BrowserRouter basename={ROUTER_BASENAME}>
        <AppShell />
      </BrowserRouter>
    </LangProvider>
  );
}
